<div id="group-assignment" class="row row-m-20">
    <div id="group-assignment-container" class="h-100 col-12 col-p-20 py-4">
        <div id="group-assignment-header" class="w-100">
            <label class="section-title" cvLocalizedText langSection="MarketPlace_Management"
                langKey="Employee_Group">Employee
                Group</label>
            <hr class="m-0">
            <label class="section-subtitle pt-3" cvLocalizedText langSection="MarketPlace_Management"
                langKey="Assigned_All_Groups_Default">
                Assigned to all groups by default. You can choose specific group who can purchase this product.
            </label>
        </div>
        <div id="group-assignment-body" class="w-100 cx-one-ui">
            <cxone-omnibar [itemCountLabel]="assignmentsLabel" [isFilterable]="false"
                [searchPlaceholderText]="assignmentsSearchPlaceholder"
                (searchQueryChange)="onAssignmentsFilterChange($event)">
                <cxone-omnibar-custom-content id="group-assignment-cxone-omnibar">
                    <div>
                        <button id="group-assignment-remove-button" class="assign-btns btn btn-secondary"
                            [disabled]="!(agGrid?.api) || agGrid?.api.getSelectedRows().length == 0"
                            (click)="removeSelectedAssignments()" cvLocalizedText langSection="MarketPlace_Management"
                            langKey="Remove">Remove</button>
                        <button id="group-assignment-add-button" class="assign-btns btn btn-primary" (click)="openAssignModal()" cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Add">Add</button>
                    </div>
                </cxone-omnibar-custom-content>
            </cxone-omnibar>
            <ag-grid-angular #pointStoreProductAssignmentCxoneGrid *ngIf="gridOptions != null" [gridOptions]="gridOptions"
                class="group-assignment-grid ag-theme-balham cxone-grid flex-fill">
            </ag-grid-angular>
            <cv-loader [size]="'large'" [overlay]="false" *ngIf="gridOptions == null"></cv-loader>
        </div>
    </div>
</div>
